<template>
  <div>
    <a-modal title="Please Enter Income Info" :visible="modal_income_visible" @ok="submit_create"
      @cancel="modal_income_visible = false">
      <a-form layout="horizontal" width="300">
        <a-form-item label="Vessel:" :labelCol="{ span: 6 }" :wrapperCol="{ span: 16 }">
          <!-- <v-suggest :style="{width:'100%'}" :data="vessels" :show-field="(row)=>{return row.vessel_ref+'---'+row.vessel_name}" @values="(d)=>{ income_to_create.vessel_id = d.id}" id="v-sug-vsl"></v-suggest> -->

          <a-select showSearch style="width: 300px" :showArrow="false" :filterOption="false" @search="on_search_vessel"
            v-model="income_to_create.vessel_id">
            <a-select-option v-for="v in vsl_suggested" :key="v.id">{{ v.vessel_ref }}--{{ v.vessel_name
              }}</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item label="Date:" :labelCol="{ span: 6 }" :wrapperCol="{ span: 16 }">
          <a-date-picker size="small" v-model="income_to_create.date_obj" />
        </a-form-item>

        <a-form-item label="Items:" :labelCol="{ span: 6 }" :wrapperCol="{ span: 16 }">
          <!-- <v-suggest :style="{width:'100%'}" :data="item_list" show-field="desc" v-model="income_to_create.items" id="v-sug-item"></v-suggest> -->

          <a-auto-complete :dataSource="item_suggested" style="width: 300px" @search="on_search_items"
            v-model="income_to_create.items" />
        </a-form-item>

        <a-form-item label="Messrs:" :labelCol="{ span: 6 }" :wrapperCol="{ span: 16 }">
          <!-- <v-suggest :style="{width:'100%'}" :data="messrs_list" show-field="desc" v-model="income_to_create.messrs" id="v-sug-messr"></v-suggest> -->

          <a-auto-complete :dataSource="messrs_suggested" style="width: 300px" @search="on_search_messrs"
            v-model="income_to_create.messrs" />
        </a-form-item>

        <a-form-item label="Amount:" :labelCol="{ span: 6 }" :wrapperCol="{ span: 16 }">
          <a-input size="small" type="number" step="0.01" v-model="income_to_create.amount" />
        </a-form-item>

        <a-form-item label="Remarks:" :labelCol="{ span: 6 }" :wrapperCol="{ span: 16 }">
          <a-input size="small" v-model="income_to_create.remarks" />
        </a-form-item>

        <a-form-item label="Received:" :labelCol="{ span: 6 }" :wrapperCol="{ span: 16 }">
          <a-select size="small" v-model="income_to_create.received">
            <a-select-option value="true">Y</a-select-option>
            <a-select-option value="false">N</a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
    </a-modal>

    <a-button :style="{ marginBottom: '30px' }" type="primary" @click="modal_income_visible = true">Create</a-button>

    <a-table size="small" :dataSource="table_data" :columns="columns" rowKey="id"
      :pagination="{ showSizeChanger: true, pageSizeOptions: ['10', '100'] }">
      <div slot="text_filter" slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
        style="padding: 8px">
        <a-input v-ant-ref="(c) => (item_search_input = c)" :placeholder="`Search ${column.dataIndex}`"
          :value="selectedKeys[0]" @change="(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])"
          @pressEnter="() => confirm()" style="width: 188px; margin-bottom: 8px; display: block" />
        <a-button type="primary" @click="() => confirm()" icon="search" size="small"
          style="width: 90px; margin-right: 8px">Search</a-button>
        <a-button @click="() => clearFilters()" size="small" style="width: 90px">Reset</a-button>
      </div>
      <div slot="date_filter" slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters }"
        style="padding: 8px">
        <a-range-picker size="small" style="width: 200px; margin-bottom: 8px; display: block"
          v-ant-ref="(c) => (date_range_input = c)" v-model="search_date_range"
          @change="setSelectedKeys(search_date_range)" />
        <a-button @click="confirm" type="primary" icon="search" size="small"
          style="width: 90px; margin-right: 8px">Search</a-button>

        <a-button @click="clearFilters" size="small" style="width: 90px; margin-left: 8px">Reset</a-button>
      </div>

      <!-- Income Data Display and Edit -->
      <div v-for="col in [
        'vessel_name',
        'items',
        'date',
        'messrs',
        'amount',
        'remarks',
        'received',
      ]" :slot="col" slot-scope="text, record" :key="col">
        <div style="text-align: center">
          <template v-if="record.editable">
            <a-select v-if="col == 'vessel_name'" :value="text" showSearch style="width: 150px" :showArrow="false"
              :filterOption="false" @search="on_search_vessel" @change="(e) => change_data(e, record, col)">
              <a-select-option v-for="v in vsl_suggested" :key="v.id">{{ v.vessel_ref }}/{{ v.vessel_name
                }}</a-select-option>
            </a-select>

            <a-select v-if="col == 'received'" :value="text" :style="{ width: '50px' }" size="small"
              @change="(e) => change_data(e, record, col)">
              <a-select-option value="Y">Y</a-select-option>
              <a-select-option value="N">N</a-select-option>
            </a-select>

            <a-auto-complete style="width: 200px" :dataSource="item_suggested" size="small" v-if="col == 'items'"
              @search="on_search_items" v-model="record.items" @change="(e) => change_data(e, record, col)" />
            <a-auto-complete style="width: 200px" :dataSource="messrs_suggested" size="small" v-if="col == 'messrs'"
              @search="on_search_messrs" v-model="record.messrs" @change="(e) => change_data(e, record, col)" />

            <a-input v-if="col == 'amount'" :value="text" size="small" type="number" step="0.01"
              @change="(e) => change_data(e.target.value, record, col)" />
            <a-input v-if="col == 'remarks'" :value="text" size="small"
              @change="(e) => change_data(e.target.value, record, col)" />
            <a-date-picker v-if="col == 'date'" size="small" v-model="record.date_obj"
              @change="(e) => change_data(e, record, col)" />
          </template>

          <template v-else>
            <template v-if="col == 'received'">
              <div v-if="text == 'Y'">{{ text }}</div>
              <div v-else style="color: red; font-weight: 900">{{ text }}</div>
            </template>
            <template v-else-if="col == 'amount'">
              {{ text.toLocaleString("en-US", { style: "currency", currency: "USD" }) }}
            </template>
            <template v-else>
              {{ text }}
            </template>
          </template>
        </div>
      </div>

      <!-- audited -->
      <template slot="audited" slot-scope="text">
        <div v-if="text == 'Y'">{{ text }}</div>
        <div v-else style="color: red; font-weight: 900">{{ text }}</div>
      </template>

      <template slot="creator" slot-scope="text">
        {{ text ? users.filter((u) => u.id == text)[0].account : "N/A" }}
      </template>

      <!-- Operations -->
      <template slot="operation" slot-scope="text, record">
        <div class="editable-row-operations" style="text-align: center">
          <span v-if="record.editable">
            <a-popconfirm title="About to Save?" @confirm="() => save(record.id)">
              <a>Save</a>
            </a-popconfirm>

            <a-popconfirm title="Sure to cancel?" @confirm="() => cancel(record.id)">
              <a>Cancel</a>
            </a-popconfirm>
          </span>

          <span v-else>
            <a @click="() => edit(record.id)">Edit</a>

            <a-popconfirm title="Sure to Delete?" @confirm="() => delete_record(record.id)">
              <a>Delete</a>
            </a-popconfirm>

            <a-popconfirm v-if="userinfo.group !== 'book-keeper'" @confirm="() => check_confirm(record.id)"
              title="Correct Sure?">
              <a>Check</a>
            </a-popconfirm>
          </span>
        </div>
      </template>

      <template slot="upload" slot-scope="text, record" style="text-align: center">
        <a-upload-dragger size="small" name="file" :multiple="true" @change="(info) => change_upload(record, info)"
          :fileList="record.attachments" :action="$store.state.base_url + '/upload'" :headers="headers">
          <p>
            <a-icon type="inbox" />
          </p>
          <p>Click or drag file to this area to upload</p>
        </a-upload-dragger>
      </template>
    </a-table>
  </div>
</template>

<script>
import moment from "moment";
import userinfo from "../utils/userinfo.js";
import users_filter from "./users_filter.js";

export default {
  name: "income",
  data() {
    // ES7 deep copy syntax ... will interate and deep copy an object's prop or element of array
    this.cacheData = [];
    return {
      headers: {
        access_token: userinfo.get().access_token,
      },

      userinfo: userinfo.get(),

      messrs_list: [],
      item_list: [],
      users: [],

      vessels: [],
      table_data: [],
      columns: [
        {
          title: "ID#",
          dataIndex: "id",
          key: "id",
          sortOrder: "descend",
          sorter: (a, b) => a.id - b.id,
        },
        {
          title: "Vessel_Ref",
          dataIndex: "vessel_ref",
          key: "vessel_ref",
          scopedSlots: {
            customRender: "vessel_ref",
          },
        },
        {
          title: "Vessel_Name",
          dataIndex: "vessel_name",
          key: "vessel_name",
          scopedSlots: {
            customRender: "vessel_name",
          },
          onFilter: (value, record) =>
            record.vessel_ref.toLowerCase().includes(value.toLowerCase()),
          filters: [],
        },
        {
          title: "Creator",
          dataIndex: "creator",
          scopedSlots: { customRender: "creator" },
          onFilter: (value, record) => {
            if (record.creator) {
              return record.creator == value
            } else {
              return false
            }
          },
          filters: users_filter
        },
        {
          title: "Date",
          dataIndex: "date",
          key: "date",
          scopedSlots: {
            filterDropdown: "date_filter",
            customRender: "date",
          },
          onFilter: (value, record) => {
            var date = moment(record.date).set({
              hour: 12,
              minute: 0,
              second: 0,
            });
            var start = this.search_date_range[0].set({
              hour: 0,
              minute: 0,
              second: 0,
            });
            var end = this.search_date_range[1].set({
              hour: 0,
              minute: 0,
              second: 0,
            });
            if (date.isBetween(start, end, "day", "[]")) {
              return true;
            } else {
              return false;
            }
          },
          onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
              setTimeout(() => {
                this.date_range_input.focus();
              }, 0);
            }
          },
        },
        {
          title: "Items",
          dataIndex: "items",
          key: "items",
          scopedSlots: {
            filterDropdown: "text_filter",
            customRender: "items",
          },
          onFilter: (value, record) =>
            record.items.toLowerCase().includes(value.toLowerCase()),
          onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
              setTimeout(() => {
                this.item_search_input.focus();
              }, 0);
            }
          },
        },
        {
          title: "Messrs",
          dataIndex: "messrs",
          key: "messrs",
          scopedSlots: {
            filterDropdown: "text_filter",
            customRender: "messrs",
          },
          onFilter: (value, record) =>
            record.messrs.toLowerCase().includes(value.toLowerCase()),
          onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
              setTimeout(() => {
                this.item_search_input.focus();
              }, 0);
            }
          },
        },
        {
          title: "Amount",
          dataIndex: "amount",
          key: "amount",
          scopedSlots: {
            filterDropdown: "text_filter",
            customRender: "amount",
          },
          sorter: (a, b) => a.id - b.id,
          onFilter: (value, record) =>
            record.amount.toLowerCase().includes(value.toLowerCase()),
          onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
              setTimeout(() => {
                this.item_search_input.focus();
              }, 0);
            }
          },
        },
        {
          title: "Remarks",
          dataIndex: "remarks",
          key: "remarks",
          scopedSlots: {
            filterDropdown: "text_filter",
            customRender: "remarks",
          },
          onFilter: (value, record) =>
            record.remarks.toLowerCase().includes(value.toLowerCase()),
          onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
              setTimeout(() => {
                this.item_search_input.focus();
              }, 0);
            }
          },
        },
        {
          title: "Received?",
          dataIndex: "received",
          key: "received",
          scopedSlots: {
            customRender: "received",
          },
          onFilter: (value, record) => {
            if (record.editable) {
              return true;
            }
            return record.received.toLowerCase().includes(value.toLowerCase());
          },
          filters: [
            { text: "Yes", value: "Y" },
            { text: "No", value: "N" },
          ],
        },
        {
          title: "Checked?",
          dataIndex: "audited",
          key: "audited",
          align: "center",
          scopedSlots: { customRender: "audited" },
          onFilter: (value, record) =>
            record.audited.toLowerCase().includes(value.toLowerCase()),
          filters: [
            { text: "Yes", value: "Y" },
            { text: "No", value: "N" },
          ],
        },
        {
          title: "upload",
          dataIndex: "upload",
          scopedSlots: { customRender: "upload" },
        },
        {
          title: "operation",
          dataIndex: "operation",
          scopedSlots: { customRender: "operation" },
        },
      ],

      // filter controls and data holder
      item_search_input: null,
      search_date_range: [],
      date_range_input: null,

      //create modal
      modal_income_visible: false,
      income_to_create: {
        received: "true",
      },

      // auto complete
      vsl_suggested: [],
      item_suggested: [],
      messrs_suggested: [],
    };
  },
  methods: {
    refresh() {
      var params = {};
      var vid = this.$route.params.vid;
      if (vid == "all") {
        params = {};
      } else {
        params.vessel_id = vid;
      }

      this.shipIDs = [];
      this.$http.post(this.$store.state.base_url + "/income/r", params).then((res) => {
        if (res.data.status == 1) {
          var data = res.data.data;
          data.forEach((d) => {
            d.vessel_ref = "MV" + (d.vessel_id + 10000 + "").substr(1, 4);
            d.date_obj = moment(d.date);
            d.received = d.received ? "Y" : "N";
            d.audited = d.audited ? "Y" : "N";

            // d.attachments.forEach(a => {
            //   a.name = a.filename
            //   a.url = this.$store.state.site_url + a.path
            //   a.status = "done"
            //   a.uid = a.path
            // })
          });
          // set cacheData and table_data
          this.cacheData = data.map((item) => ({ ...item }));
          this.table_data = data;

          // get suggestion list
          this.get_suggestion_list();
        }
      });
    },
    get_vesesl_list() {
      this.vessels = [];
      this.$http.post(this.$store.state.base_url + "/vessel/r", {}).then((res) => {
        if (res.data.status == 1) {
          var data = res.data.data;
          this.columns[2].filters = [];
          data.forEach((d) => {
            d.vessel_ref = "MV" + (d.id + 10000 + "").substr(1, 4);
            this.columns[2].filters.push({
              text: d.vessel_name,
              value: d.vessel_ref,
            });
          });
          this.vessels = data;
        }
      });
    },

    get_suggestion_list() {
      this.messrs_list = [];
      this.item_list = [];

      this.table_data.forEach((d) => {
        var i = this.messrs_list.findIndex((m) => m == d.messrs);
        if (i == -1) {
          this.messrs_list.push(d.messrs);
        }
        var j = this.item_list.findIndex((itm) => itm == d.items);
        if (j == -1) {
          this.item_list.push(d.items);
        }
      });
    },

    // table edit function
    edit(key) {
      const newData = [...this.table_data];
      const target = newData.filter((item) => key === item.id)[0];
      if (target) {
        target.editable = true;
        this.table_data = newData;
      }
    },
    change_data(value, record, col) {
      console.log("Value Changed:", value);
      const newData = [...this.table_data];
      const target = newData.filter((item) => record.id === item.id)[0];
      if (target) {
        switch (col) {
          case "vessel_name":
            var new_v = this.vessels.filter((item) => value == item.id)[0];
            target["vessel_name"] = new_v.vessel_name;
            target["vessel_ref"] = "MV" + (value + 10000 + "").substr(1, 4);
            target["vessel_id"] = value;
            break;
          case "items":
            target["items"] = value;
            break;
          case "messrs":
            target["messrs"] = value;
            break;
          case "date":
            target[col] = value.format("YYYY-MM-DD");
            break;
          default:
            target[col] = value;
            break;
        }
      }
      this.table_data = newData;
    },
    save(key) {
      const newData = [...this.table_data];
      const target = newData.filter((item) => key === item.id)[0];
      // net work operation hare
      // success and fails
      var data = JSON.parse(JSON.stringify(target));
      delete data.vessel_ref;
      data.received = data.received == "Y" ? true : false;
      delete data.date_obj;
      delete data.lasteditor;
      delete data.lastupdate;
      delete data.vessel_name;
      this.$http.post(this.$store.state.base_url + "/income/u", data).then((res) => {
        if (res.data.status == 1) {
          this.$message.info(res.data.msg);
          delete target.editable;
          this.table_data = newData;
          this.cacheData = newData.map((item) => ({ ...item }));
        }
      });
    },
    cancel(key) {
      const newData = [...this.table_data];
      const target = newData.filter((item) => key === item.id)[0];
      if (target) {
        Object.assign(target, this.cacheData.filter((item) => key === item.id)[0]);
        delete target.editable;
        this.table_data = newData;
      }
    },
    change_upload(record, info) {
      if (info.file.status === "done") {
        for (var i = 0; i < info.fileList.length; i++) {
          if (
            info.fileList[i].hasOwnProperty("percent") &
            (info.fileList[i].percent == 100)
          ) {
            var tmp = {};
            tmp.name = info.fileList[i].name;
            tmp.filename = info.fileList[i].name;
            tmp.uid = info.fileList[i].response.data[0].path;
            tmp.path = info.fileList[i].response.data[0].path;
            tmp.url = this.$store.state.site_url + info.file.response.data[0].path;
            tmp.status = "done";
            info.fileList[i] = tmp;
          }
        }
        record.attachments = info.fileList;

        var r = JSON.parse(JSON.stringify(record));
        r.received = r.received == "Y" ? true : false;

        this.$http.post(this.$store.state.base_url + "/income/u", record).then((res) => {
          if (res.data.status == 1) {
            this.$message.info("Upload Attachment Success");
          }
        });
      }
      if (info.file.status === "removed") {
        console.log("removed");
        record.attachments = info.fileList;

        r = JSON.parse(JSON.stringify(record));
        r.received = r.received == "Y" ? true : false;

        this.$http.post(this.$store.state.base_url + "/income/u", record).then((res) => {
          if (res.data.status == 1) {
            this.$message.info("Upload Attachment Success");
          }
        });
      }
      record.attachments = info.fileList;
    },

    // data submit function
    delete_record(id) {
      this.$http
        .post(this.$store.state.base_url + "/income/d", { id: id })
        .then((res) => {
          if (res.data.status == 1) {
            var index = this.table_data.findIndex((e) => {
              return e.id == id;
            });

            // delete and update data
            var newData = [...this.table_data];
            newData.splice(index, 1);
            this.table_data = newData;
            this.cacheData = newData.map((item) => ({ ...item }));
          }
        });
    },
    submit_create() {
      delete this.income_to_create.date_obj;
      this.$http
        .post(this.$store.state.base_url + "/income/c", this.income_to_create)
        .then((res) => {
          if (res.data.status == 1) {
            this.modal_income_visible = false;
            this.income_to_create = {
              received: "true",
            };
            // document.getElementById("v-sug-vsl").children[0].children[1].click()
            // document.getElementById("v-sug-item").children[0].children[1].click()
            // document.getElementById("v-sug-messr").children[0].children[1].click()
            this.refresh();
          }
        });
    },
    check_confirm(id) {
      this.$http
        .post(this.$store.state.base_url + "/income/u", { id: id, audited: true })
        .then((res) => {
          if (res.data.status == 1) {
            this.refresh();
          }
        });
    },

    // auto complete function
    on_search_vessel(value) {
      if ((value !== "") & (value.length >= 3)) {
        this.vsl_suggested = this.vessels.filter((v) => {
          return v.vessel_name.toUpperCase().includes(value.toUpperCase());
        });
      }
    },

    on_search_items(value) {
      if ((value !== "") & (value.length >= 3)) {
        this.item_suggested = this.item_list.filter((i) => {
          return i.toUpperCase().includes(value.toUpperCase());
        });
      }
    },
    on_search_messrs(value) {
      if ((value !== "") & (value.length >= 3)) {
        this.messrs_suggested = this.messrs_list.filter((m) => {
          return m.toUpperCase().includes(value.toUpperCase());
        });
      }
    },
  },

  mounted() {
    this.refresh();
    this.get_vesesl_list();
    this.$http.post(this.$store.state.base_url + "/user/r", {}).then((res) => {
      if (res.data.status == 1) {
        var data = res.data.data;
        this.users = data;
      }
    });
  },
  watch: {
    income_to_create() {
      if (this.income_to_create.date_obj) {
        this.income_to_create.date = this.income_to_create.date_obj.format("YYYY-MM-DD");
      }
    },
    $route: {
      deep: true,
      handler() {
        this.refresh();
      },
    },
  },
};
</script>
<style>
.editable-row-operations a {
  margin-right: 8px;
}

/* v-suggestion */
div.v-suggest input[type="text"] {
  padding: 1px 10px 1px 6px;
}

div.v-suggest div.sg-clear {
  padding: 1px;
}
</style>
